import {
  calendarDateSchema,
  ianaTimeZoneSchema,
  matchViewSchema,
  opaquePublicIdSchema,
  publicCompetitionCodeSchema,
} from '@ballpeek/api/client'
import { z } from 'zod'
import { parsePublicFootballRouteInput } from '~/lib/public-football-read'

export const matchesRouteSearchSchema = z.object({
  view: matchViewSchema.optional(),
  competition: publicCompetitionCodeSchema.optional(),
  season: z.coerce.number().int().optional(),
  team: opaquePublicIdSchema.optional(),
  date: calendarDateSchema.optional(),
  timeZone: ianaTimeZoneSchema.optional(),
  page: z.coerce.number().int().min(1).max(1000).optional(),
}).strict().superRefine((search, context) => {
  if ((search.competition === undefined) !== (search.season === undefined)) {
    context.addIssue({
      code: 'custom',
      path: search.competition === undefined ? ['competition'] : ['season'],
      message: 'competition and season must be provided together',
    })
  }
})

export const matchesSearchSchema = matchesRouteSearchSchema.transform(search => ({
  ...search,
  view: search.view ?? 'live',
  timeZone: search.timeZone ?? 'UTC',
  page: search.page ?? 1,
}))

export type MatchesSearchInput = z.output<typeof matchesRouteSearchSchema>
export type MatchesSearch = z.output<typeof matchesSearchSchema>

export function parseMatchesSearch(search: unknown): MatchesSearchInput {
  return parsePublicFootballRouteInput(matchesRouteSearchSchema, search)
}

export function resolveMatchesSearch(search: MatchesSearchInput): MatchesSearch {
  return matchesSearchSchema.parse(search)
}
